export function generateWebinarAccessToken(): string {
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);

  const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
